var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cart',[_c('div',{staticClass:"bg-white"},[_c('app-tabs-panel',{attrs:{"items":_vm.tabs,"vertical":false},scopedSlots:_vm._u([{key:"content",fn:function(ref){
var active = ref.active;
return [_c('div',{staticClass:"p-3"},[_c(("checkout-" + (active.id)),{tag:"component"})],1)]}}]),model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }